<template>
  <v-container>
    <PageTitle>
      iOS App Configuration File
      <template v-slot:buttons>
        <v-btn href="https://github.com/rwbutler/Updates"
               target="_blank">
          Documentation
        </v-btn>
      </template>
    </PageTitle>
    <v-form @submit.prevent="submit"
            :disabled="form.busy">
      <v-card class="mb-4">
        <v-card-text>
          <v-select v-model="form.check_for"
                    label="Check for"
                    :items="checkForOptions"
                    outlined
                    dense
                    required>
          </v-select>

          <v-select v-model="form.notify"
                    label="Notify"
                    :items="notifyOptions"
                    outlined
                    dense
                    required>
          </v-select>

          <v-select v-model="form.comparing"
                    label="Comparing"
                    :items="comparingOptions"
                    outlined
                    dense
                    required>
          </v-select>

          <v-select v-model="form.update_type"
                    label="Update Type"
                    :items="updateTypeOptions"
                    outlined
                    dense
                    required>
          </v-select>

          <v-text-field v-model="form.min_os_required"
                        label="Minimum iOS version"
                        outlined
                        dense
                        required>
          </v-text-field>

          <v-text-field v-model="form.min_required_app_version"
                        label="Minimum required app version"
                        outlined
                        dense
                        required>
          </v-text-field>
        </v-card-text>
        <v-card-actions class="px-4">
          <v-btn type="submit"
                 color="primary"
                 :disabled="form.busy">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-card class="mb-4">
      <v-card-title>
        Current Configuration
      </v-card-title>
      <v-card-text>
        <pre>{{ configuration }}</pre>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import axios from '../../services/axiosService';
import PageTitle from '../../components/PageTitle.vue';
import {isObject} from 'lodash';

export default {
  components: {PageTitle},
  data() {
    return {
      configuration: null,
      // @see https://github.com/rwbutler/Updates
      form: new Form({
        check_for: 'automatically',
        notify: 'once',
        comparing: 'patch-versions',
        min_os_required: '16.0',
        update_type: 'soft',
        min_required_app_version: '3.21.0',
      }),
      checkForOptions: [
        'automatically',
        'manually',
      ],
      notifyOptions: [
        'once',
        'twice',
        'thrice',
        'always',
      ],
      comparingOptions: [
        'major-versions',
        'minor-versions',
        'patch-versions',
      ],
      updateTypeOptions: [
        'soft',
        'hard',
      ],
      min_os_required: '16.0',
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        const {data: configuration} = await axios.get('/api/apple/app/configuration-file');
        this.configuration = configuration;
        if (isObject(configuration) && isObject(configuration.updates)) {
          this.form.check_for = configuration.updates['check-for'];
          this.form.notify = configuration.updates.notify;
          this.form.comparing = configuration.updates.comparing;
          this.form.min_os_required = configuration.updates['min-os-required'];
          this.form.update_type = configuration.updates['update-type'] ?? 'soft';
          this.form.min_required_app_version = configuration.updates['min-required-app-version'] ?? '3.21.0';
        } else {
          throw new Error('The configuration file is invalid.');
        }
      } catch (e) {
        this.$toast.error(e.message);
      }
    },
    async submit() {
      try {
        await this.form.post(`/api/apple/app/configuration-file`);
        await this.fetchData();
        this.$toast.success('The iOS configuration file has been updated.');
      } catch (e) {
        this.$toast.error('The iOS configuration file could not be updated.');
      }
    }
  }
}
</script>
